/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FixedWingLineOptionsResponse } from '../../models/fixed-wing-line-options-response';

export interface ListFixedWingLines$Params {
  date: string;
}

export function listFixedWingLines(http: HttpClient, rootUrl: string, params: ListFixedWingLines$Params, context?: HttpContext): Observable<StrictHttpResponse<FixedWingLineOptionsResponse>> {
  const rb = new RequestBuilder(rootUrl, listFixedWingLines.PATH, 'get');
  if (params) {
    rb.query('date', params.date, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FixedWingLineOptionsResponse>;
    })
  );
}

listFixedWingLines.PATH = '/api/scheduler/daily-line-schedule/fixed-wing/lines';
